module.exports = __webpack_public_path__ + "images/feature/20150709_01-7c2e30c5cee19ace7bb8c96c8e1c79db.png";